import { c as _c } from "react/compiler-runtime";
import type { EntityCard } from '@onefootprint/types';
import { Select } from '@onefootprint/ui';
import CardIcon from '../../../card-icon';
export type CardSelectorProps = {
  selected?: EntityCard;
  onChange: (item: EntityCard) => void;
  cards: EntityCard[];
};
export const CardSelector = t0 => {
  const $ = _c(9);
  const {
    selected,
    onChange,
    cards
  } = t0;
  let t1;
  if ($[0] !== cards || $[1] !== onChange) {
    t1 = newValue => {
      const newItem = cards.find(card => card.alias === newValue);
      if (newItem) {
        onChange(newItem);
      }
    };
    $[0] = cards;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChange = t1;
  let t2;
  if ($[3] !== cards) {
    t2 = cards.map(_temp);
    $[3] = cards;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const options = t2;
  const t3 = selected?.alias || "";
  let t4;
  if ($[5] !== handleChange || $[6] !== options || $[7] !== t3) {
    t4 = <Select value={t3} onChange={handleChange} options={options} size="compact" aria-label="Select a card" />;
    $[5] = handleChange;
    $[6] = options;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default CardSelector;
function _temp(card_0) {
  return {
    value: card_0.alias || "",
    label: `${card_0.number_last4 ? `•••• ${card_0.number_last4}` : "\u2022\u2022\u2022\u2022"} (${card_0.alias || ""})`,
    component: <div className="flex items-center gap-1">{card_0.issuer && <CardIcon issuer={card_0.issuer} />}{`${card_0.number_last4 ? `•••• ${card_0.number_last4}` : "\u2022\u2022\u2022\u2022"} (${card_0.alias || ""})`}</div>
  };
}